import script from "./ElencoContabili.vue?vue&type=script&setup=true&lang=js"
export * from "./ElencoContabili.vue?vue&type=script&setup=true&lang=js"

import "./ElencoContabili.vue?vue&type=style&index=0&id=1c7644bc&lang=css"

const __exports__ = script;

export default __exports__